module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/perfect/perfect-01-a39a9557657ff06fb6959f88f75c6a3e.jpg";